<template>
    <div class="boxed-container">
        <main>
            <slot />
        </main>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.boxed-container {
    width: $desktop;
    max-width: 100%;
    padding: $s-xl $s-xs;
    margin: 0 auto;
}

@include tablet {
    .boxed-container {
        padding: $s-xxl $s-m 0;
    }
}
</style>
